import { array, boolean, number, object, string } from 'yup';

const serviceSummaryMapper: { [key: string]: string } = {
    total: 'Total servicios',
};

const editPlanSchema = object().shape({
    description: string()
        .min(3, 'El nombre debe contener al menos 3 caracteres')
        .required('El nombre es obligatorio'),
    frequencyId: number().min(1).required('Es obligatorio'),
    price: number()
        .min(1, 'El precio debe ser mínimo de $1.00')
        .required('El precio del plan es obligatorio'),
    isPublic: boolean().required(),
    isActive: boolean().required(),
    isForBusiness: boolean().required(),
});

const createPlanSchema = object().shape({
    description: string()
        .min(3, 'El nombre debe contener al menos 3 caracteres')
        .required('El nombre es obligatorio'),
    frequencyId: number().min(1).required('Es obligatorio'),
    price: number()
        .min(1, 'Precio mínimo es $1.00')
        .required('El precio del plan es obligatorio'),
    isPublic: boolean().required(),
    isActive: boolean().required(),
    isForBusiness: boolean().required(),
});

const createServiceSchema = object().shape({
    name: string().min(3).required('Es obligatorio'),
    code: string().min(0).required('Es obligatorio'),
    description: string().min(3).required('Es obligatoria'),
    totalFreeTowingServices: number().min(0).optional(),
    totalFreeAmbulanceServices: number().min(0).optional(),
    towingEligibilityDays: number()
        .min(1, 'Mínimo 1 día')
        .required('Es obligatorio'),
    perks: array()
        .of(
            object().shape({
                order: number().min(1).required(),
                name: string().min(3).required(),
            })
        )
        .optional(),
});

const updateServiceSchema = object().shape({
    name: string().min(3).required('Es obligatorio'),
    code: string().min(3).optional(),
    description: string().min(3).required('Es obligatoria'),
    totalFreeTowingServices: number().min(0).optional(),
    totalFreeAmbulanceServices: number().min(0).optional(),
    towingEligibilityDays: number()
        .min(1, 'Mínimo 1 día')
        .required('Es obligatorio'),
    perks: array()
        .of(
            object().shape({
                order: number().min(1).required(),
                name: string().min(3).required(),
            })
        )
        .optional(),
});

export {
    serviceSummaryMapper,
    editPlanSchema,
    createPlanSchema,
    createServiceSchema,
    updateServiceSchema,
};
